import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Body from "./Body";
import { BsFillPersonFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import "../Components/css/loggin.css";
import "../Components/css/responsive.css";
import "../Components/css/SignUp2.css";
import { db, auth } from "./FireBaseConfig";
import { doc, updateDoc } from "firebase/firestore";
import { toast } from "react-toastify";

const SignUpPhase2 = () => {
  const [data, setData] = useState({
    dateofbirth: "",
    gender: "",
   
  });

  const { dateofbirth, gender } = data;

  let { uid } = auth.currentUser;
  console.log(uid);
  let navigate = useNavigate();

  const valuesChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const SaveData = async (e) => {
    e.preventDefault();
    if (dateofbirth !== "" && gender !== "") {
      try {
        let res = await updateDoc(doc(db, "users", uid), {
          dateofbirth,
          gender,
        });
        navigate("/signUpPhase3");
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    } else if (dateofbirth == "" && gender == "") {
      toast.error("Please Enter Feild!!");
    }
  };
  return (
    <>
      <Navbar />
      <div className="main-containerr bgclr">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Body />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <div className="main-form mt-5">
                <div>
                  <div className="Info text-white">
                    <h3 className=" text-white mb-2">RAFFLE MANIA</h3>
                    <p>Sign Up</p>
                    <form className="formInputs mt-4">
                      <label for="email">DOB</label>
                      <div className="form-group d-flex">
                        <input
                          type="date"
                          className="text-white w-100"
                          id="email"
                          value={dateofbirth}
                          onChange={valuesChange}
                          name="dateofbirth"
                        />
                      </div>
                      <label for="email">GENDER</label>
                      <div className="form-group d-flex">
                        <input
                          type="text"
                          className="text-white w-100"
                          placeholder="Enter First Name"
                          id="email"
                          value={gender}
                          onChange={valuesChange}
                          name="gender"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className=" btnDiv  pl-3 pr-3">
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn w-50 m-1 bg-white  signBtn2"
                      onClick={() => {
                        navigate(`/SignUp`);
                      }}
                    >
                      Previous
                    </button>
                    <button
                      className="btn w-50 m-1 bg-white signBtn2"
                      onClick={SaveData}
                    >
                      Next
                    </button>
                  </div>

                  <p className="text-white p-3">
                    Already Have an Account?
                    <span>
                      <a
                        className="text-primary"
                        onClick={() => {
                          navigate(`/`);
                        }}
                      >
                        Log In
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignUpPhase2;
